import { components } from '@src/types/schema';

export type ConfigDto = components['schemas']['ConfigDto'];

export type ProductDto = components['schemas']['ProductDto'];

export type SampleDto = components['schemas']['SampleDto'];
export type SampleDetailsDto = components['schemas']['SampleDetailsDto'];
export type GenerateSampleCodesDto =
  components['schemas']['GenerateSampleCodesDto'];

export type ParameterDto = components['schemas']['ParameterDto'];

export type RegulationDto = components['schemas']['RegulationDto'];

export type ImageDto = components['schemas']['ImageDto'];

export enum SampleFormat {
  NUMERIC = 'numeric',
  STRING = 'string',
  PERCENTAGE = 'percentage',
  YES_NO = 'yesNo',
}

export enum SampleStatus {
  ACTIVATED = 'ACTIVATED',
  ARRIVED_IN_LAB = 'ARRIVED_IN_LAB',
  DONE = 'DONE',
  SHIPPED = 'SHIPPED',
}

export enum ButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
  CLOSE = 'CLOSE',
  WHITE = 'WHITE',
}
